import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { OrderStatusRequestBody, OrderStatusResponse } from "./types";

export class OrderStatusAPI extends BaseAPI<
  OrderStatusRequestBody,
  OrderStatusResponse
> {
  protected route = ApiRoutes.order.status;
  protected method = RequestMethod.PUT;
  protected params = ["order_id"];
}
